export const getLastDayOfMonth = (month: string, year?: number): number => {
  const useYear = year || new Date().getFullYear();
  const nextMonth = new Date(useYear, parseInt(month), 1);
  nextMonth.setDate(nextMonth.getDate() - 1);
  return nextMonth.getDate();
};
